import { Action } from "redux";

import { OrganizationKeyName } from "../../../model/Organization";

export const LIST = "PARTNERSHIP:LIST";

export interface ListAction extends Action {
  type: typeof LIST;
  organization: OrganizationKeyName;
}

export const listAction = (organization: OrganizationKeyName): ListAction => ({
  type: LIST,
  organization,
});
